<template>
  <div @scroll="listenForPagination">
      <div
        dir="ltr"
        style="margin-top: 0; padding-top: 0;"
        class="toggle_resources is-flex is-align-items-center is-justify-content-center"
      >
        <a
          @click="toggleResource('Applicants')"
          :class="{ 'is-info': resource_selected == 'Applicants' }"
          class="button is-link"
          >Applicants</a
        >
        <div style="width: 10px;"></div>
        <a
          @click="toggleResource('Companies')"
          :class="{ 'is-info': resource_selected == 'Companies' }"
          class="button is-link"
          >Companies</a
        >
        <div style="width: 10px;"></div>
        <a
          @click="toggleResource('Positions')"
          :class="{ 'is-info': resource_selected == 'Positions' }"
          class="button is-link"
          >Positions</a
        >
        <div style="width: 10px;"></div>
        <a
          @click="toggleResource('Offers')"
          :class="{ 'is-info': resource_selected == 'Offers' }"
          class="button is-link"
          >Offers</a
        >
        <div style="width: 10px;"></div>
        <router-link
          :to="{ name: 'admin-applicants', query: { text: payload.keyword } }"
          class="button is-link"
          >Texts</router-link
        >
        <div style="width: 10px;"></div>
        <router-link
          :to="{ name: 'admin-applicants', query: { full_name: payload.keyword } }"
          class="button is-link"
          >Tags</router-link
        >
      </div>
      <div style="font-size: 14px;">
        <search-modal-applicants v-if="isShowResource('Applicants')" :results="applicants_search_results"></search-modal-applicants>
        <search-modal-companies v-if="isShowResource('Companies')" :results="companies_search_results"></search-modal-companies>
        <search-modal-positions v-if="isShowResource('Positions')" :results="positions_search_results"></search-modal-positions>
        <search-modal-offers v-if="isShowResource('Offers')" :results="offers_search_results"></search-modal-offers>
        <search-modal-texts v-if="isShowResource('Texts')" :results="texts_search_results"></search-modal-texts>
      </div>
      <div v-if="is_paginating || is_searching" class="loading center_horizontal"></div>
  </div>
</template>
<script>
import { isNumeric } from '@/custom/classes/my_utils.js'
import TimeHelper from '@/custom/classes/time_helper.js'
import SearchModalApplicants from '@/components/SearchModalApplicants'
import SearchModalCompanies from '@/components/SearchModalCompanies'
import SearchModalPositions from '@/components/SearchModalPositions'
import SearchModalOffers from '@/components/SearchModalOffers'
import SearchModalTexts from '@/components/SearchModalTexts'
import { getApplicant, getApplicants } from '@/services/applicantsApi.js'
export default {
  name: 'search-modal',
  props: ['payload'],
  data () {
    return {
      resource_selected: 'no_resource_selected',
      is_searching: false,
      is_paginating: false,
      time_helper: new TimeHelper(),
      per: 25,
      applicants_request_page: 1,
      companies_request_page: 1,
      positions_request_page: 1,
      offers_request_page: 1,
      texts_request_page: 1,
      applicants_search_results: [],
      companies_search_results: [],
      positions_search_results: [],
      offers_search_results: [],
      texts_search_results: [],
      search_timeout: {},
      requestController: new AbortController()
    }
  },
  created: function () {
    this.search()
  },
  watch: {
    payload: {
      handler () {
        this.search()
      },
      deep: true
    }
  },
  methods: {
    isShowResource (resource) {
      return this.resource_selected == 'no_resource_selected' ? true : this.resource_selected == resource
    },
    toggleResource (resource) {
      let resource_selected = this.resource_selected == resource ? 'no_resource_selected' : resource
      this.resource_selected = resource_selected
      if (resource_selected == 'Texts') {
        this.makeTextsRequest(this.getRequestParams({ page: 1 }))
      }
    },
    search () {
      this.requestController.abort()
      this.requestController = new AbortController()
      this.is_searching = true
      this.makeRequests()
    },
    makeRequests () {
      let default_params = this.getRequestParams({ page: 1 })
      if (default_params.is_alert_search) {
        this.makeAlertNumberRequest(default_params.alert_number)
        return
      }
      if (this.resource_selected == 'Texts') {
        this.makeTextsRequest(default_params)
        return
      }
      this.makeApplicantsRequest(default_params)
      this.makePositionsRequest(default_params)
      this.makeCompaniesRequest(default_params)
      if (default_params.is_id_search) {
        this.makeOffersRequest(default_params)
      }
    },
    getRequestParams (additional_params) {
      let keyword = this.payload.keyword
      let text = this.trimSearchWords(keyword)
      let is_id_search = isNumeric(keyword) && !keyword.startsWith('0')
      let is_alert_search = /^a-\d+$/i.test(keyword.trim())
      let alert_number = is_alert_search ? keyword.toLowerCase().split('a-')[1] : null
      let id = is_id_search ? keyword : ''
      return {
        keyword,
        text,
        is_id_search,
        is_alert_search,
        alert_number,
        id,
        ...additional_params
      }
    },
    trimSearchWords (keyword) {
      let words = keyword.split(',')
      words[0] = words[0].split(' ').map(w => w.trim()).filter(w => w != '').join(' ')
      return words.map(w => w.trim()).join(',')
    },
    async makeApplicantsRequest ({ text: full_name, keyword, page, id, is_id_search }) {
      let response = []
      let applicantId = id
      let isIdSearch = is_id_search
      let operation_name_first_letter = this.$settings.get({ path: 'operation_name' }).charAt(0).toLowerCase()
      let position_applicant_id = keyword.toLowerCase().split(operation_name_first_letter + '-')[1]
      if (keyword.toLowerCase().startsWith(operation_name_first_letter + '-') && isNumeric(position_applicant_id)) {
        applicantId = Math.sqrt(position_applicant_id)
        isIdSearch = true
      }
      try {
        const fn = isIdSearch ? getApplicant : getApplicants
        response = await (await fn({ full_name, page, per: this.per }, { signal: this.requestController.signal }, applicantId)).data
      } catch (e) {
      } finally {
        this.setResourceSearchResults({ resource_name: 'applicants', search_results: [].concat(response) })
      }
    },
    makePositionsRequest (params) {
      let keyword = params.keyword
      let id = params.id
      let operation_name_first_letter = this.$settings.get({ path: 'operation_name' }).charAt(0).toLowerCase()
      let position_applicant_id = keyword.toLowerCase().split(operation_name_first_letter + '-')[1]
      if (keyword.toLowerCase().startsWith(operation_name_first_letter + '-') && isNumeric(position_applicant_id)) {
        id = Math.sqrt(position_applicant_id)
      }
      this.makeRequest({
        resource_name: 'positions',
        api: '/positions/' + id,
        query_data: { position_title: params.keyword, page: params.page, per: this.per, statuses: 'active,editing', custom_sort: '-position_hot' }
      })
    },
    makeCompaniesRequest (params) {
      this.makeRequest({
        resource_name: 'companies',
        api: (params.is_id_search ? '/companies/' : '/users/') + params.id,
        query_data: { resource_type: 'Company', company_name: params.keyword, page: params.page, per: this.per }
      })
    },
    makeOffersRequest (params) {
      this.makeRequest({
        resource_name: 'offers',
        api: '/offers/' + params.id,
        query_data: { page: params.page, per: this.per }
      })
    },
    makeTextsRequest (params) {
      this.makeRequest({
        resource_name: 'texts',
        api: '/resource_texts/',
        headers: 'shared_headers',
        query_data: { contains: params.keyword, current_type: 'Applicant', resource_type: 'Applicant', current_resource_id: 1, page: params.page, per: this.per }
      })
    },
    async makeAlertNumberRequest (alertNumber) {
      this.is_searching = true
      try {
        // Step 1: Get stat by ID
        const statResponse = await this.$caller.request('get', `/stats/${alertNumber}`, 'admin_headers', {}, this.requestController)

        if (statResponse && statResponse.resource_type === 'Offer') {
          // Step 2: Get offer by resource_id
          const offerId = statResponse.resource_id
          this.makeRequest({
            resource_name: 'offers',
            api: '/offers/' + offerId,
            query_data: { page: 1, per: this.per }
          })
        } else {
          // Handle case where stat doesn't point to an offer
          this.setResourceSearchResults({
            resource_name: 'offers',
            search_results: []
          })
        }
      } catch (error) {
        // Handle case where stat doesn't exist
        this.setResourceSearchResults({
          resource_name: 'offers',
          search_results: []
        })
      }
    },
    makeRequest (params) {
      this.is_searching = true
      let headers = params.headers == undefined ? 'admin_headers' : params.headers
      this.$caller.request('get', params.api, headers, params.query_data, this.requestController).then(response => {
        this.setResourceSearchResults({
          resource_name: params.resource_name,
          search_results: Array.isArray(response) ? response : [response]
        })
      }).catch(() => {
        this.setResourceSearchResults({
          resource_name: params.resource_name,
          search_results: []
        })
      })
    },
    setResourceSearchResults (params) {
      this.is_searching = false
      let resource_results_data_path = params.resource_name + '_search_results'
      if (this.is_paginating) {
        this.is_paginating = false
        this[resource_results_data_path].push(...params.search_results)
        return
      }
      this[resource_results_data_path] = params.search_results
    },
    listenForPagination (event) {
      if (this.resource_selected == 'no_resource_selected') {
        return
      }
      let modal_body = event.target
      let is_on_bottom = modal_body.scrollTop >= (modal_body.scrollHeight - modal_body.offsetHeight)
      if (is_on_bottom && !this.is_paginating) {
        this.is_paginating = true
        let resource_page_data_path = this.$utils.lowerCaseFirst(this.resource_selected) + '_request_page'
        let request_params = this.getRequestParams({ page: ++this[resource_page_data_path] })
        this['make' + this.resource_selected + 'Request'](request_params)
      }
    }
  },
  components: {
    SearchModalApplicants,
    SearchModalCompanies,
    SearchModalPositions,
    SearchModalOffers,
    SearchModalTexts
  }
}
</script>
<style scoped>
.loading {
  position: fixed;
  bottom: 20px;
  margin-top: 30px;
}
.toggle_resources {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
